import { Input, InputAdornment, theme } from '@alefeducation/ui-elements-library-core'
import { Search, TimesCircle } from '@alefeducation/ui-elements-library-icons'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { CONTENT_TYPE_KEYS_ARRAY } from '../../utils/constants'
import { debounce } from '../../utils/debounce'

type SearchBarProps = {
  onChange?: (value: string) => void
  defaultValue?: string
  contentTypes: CONTENT_TYPE_KEYS_ARRAY
}

const SearchInput = styled(Input)`
  border-color: ${theme.colors.primary[40]};
`
export const SearchBar = ({ onChange, defaultValue }: SearchBarProps) => {
  const [keyword, setKeyword] = useState<string>(defaultValue || '')

  const onSearchDebounce = useCallback(
    debounce(value => {
      ;(value.trim() === '' || value.length > 2) && onChange(value)
    }, 400),
    []
  )

  return (
    <>
      <SearchInput
        id="search_input"
        alt="input-search"
        placeholder="Search by content title..."
        defaultValue={defaultValue}
        value={keyword}
        onChange={({ target: { value } }) => {
          setKeyword(value)
          onSearchDebounce(value)
        }}
        autoComplete="one-time-code" // HACK TO DISABLE CHROME AUTOFILL
        startAdornment={
          <InputAdornment>
            <Search color={theme.colors.primary[40]} />
          </InputAdornment>
        }
        endAdornment={
          defaultValue || keyword ? (
            <InputAdornment
              data-testid="clear-search-input"
              onClick={() => {
                setKeyword('')
                onChange('')
              }}
            >
              <TimesCircle color={theme.colors.primary[40]} />
            </InputAdornment>
          ) : null
        }
        role="search"
        data-testid="search-input"
      />
    </>
  )
}
